var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owal event banner timeline container"},[_c('div',{staticClass:"owal event banner timeline date",attrs:{"title":_vm.fullFormattedDate}},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]),_c('div',{staticClass:"owal event banner timeline line"},[_c('div',{staticClass:"owal event banner timeline dot",style:(_vm.backgroundColor)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }